export default __webpack_public_path__ + "static/media/DSCF5480-1024x6832.490a3c04.jpg";